module.exports = require('../_components/@alicd/next-form/lib/index.js');


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alicd_next@0.19.78@@alicd/next/lib/form/index.js
// module id = 148
// module chunks = 0